<template>
  <transition name="fade" v-if="!isWebView">
    <div class="z-10 absolute" v-if="showCookie">
      <div class="cookie-notice">
        <div class="cookie-notice__text">
          <h1>{{ $t("cookie_notice") }}</h1>
          <p>{{ $t("cookie_message") }}</p>
          <br />
          <p class="button cursor-pointer">
            <span href="#" @click="closeCookieNotice">{{ $t("i_agree") }}</span>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LocalStorage from "@/helpers/localStorage";
import { AppsHelper } from "@/helpers/appsHelper";

export default defineComponent({
  name: "CookiesPrivacy",
  data() {
    return {
      showCookie: false as boolean,
      isWebView: false as boolean,
    };
  },
  mounted() {
    const storedCookie = LocalStorage.get("cookie_accept");
    if (storedCookie !== null) {
      const cookieAccept = JSON.parse(storedCookie) as boolean;
      if (cookieAccept) {
        this.showCookie = false;
        return;
      }
    }
    this.showCookie = true;
    this.isWebView = AppsHelper.isWebView() as boolean;
  },
  methods: {
    closeCookieNotice() {
      LocalStorage.add("cookie_accept", true);
      this.showCookie = false;
    },
  },
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

body {
  background: linear-gradient(135deg, #c2d1e8 0%, #8db4ef 50%, #c2d1e8 100%);
}
.cookie-notice {
  position: fixed;
  right: 10px;
  max-width: 300px;
  background: linear-gradient(
    rgba(60, 90, 120, 1) 0%,
    rgba(30, 60, 90, 1) 60%,
    rgba(20, 40, 60, 1) 100%
  );
  padding: 15px;
  border-radius: 32px;
  bottom: 10px;
}
.cookie-notice__text {
  color: rgb(220, 220, 220);
  text-align: justify;
  font-size: 10px;
}
.button span {
  display: block;
  text-decoration: none;
  color: #000;
}
h1 {
  font-size: 16px;
  margin: 0;
  padding: 0;
}

@media (max-width: 767px) {
  .cookie-notice {
    bottom: 60px;
  }
}
</style>
